import { Switch } from 'antd';
import React, { useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import { BarChartOutlined, LineChartOutlined } from '@ant-design/icons';

const graphColor = {
    Open: "rgba(3,122,252, 0.6)",
    Resolved: "rgba(77,163,184, 0.6)",
    Closed: "rgba(118,212,125, 0.6)",
    Pending: "rgba(220,63,69, 0.6)",
};

const LastTenDaysGraph = ({ data }) => {
    const dataSet = [
        { label: 'Closed', data: Object.values(data), fill: false, backgroundColor: graphColor['Closed'], borderColor: graphColor['Closed'] },
    ];
    const graphData = {
        labels: Object.keys(data),
        datasets: dataSet
    }

    const [graph, setGraph] = useState(true)
    const options = {
        scales: {
            y: {
                min: 0,
                ticks: {
                    stepSize: 4
                }
            },
            x: {
                title: {
                    textSize: 10,
                    display: true,
                    text: 'Last 10 Days Closed tickets'
                }
            }

        }
    }
    return (
        <div>
            {graph ? <Line options={options} data={graphData} /> : <Bar options={options} data={graphData} />}
            <div className='d-flex justify-content-center align-items-center gap-3 p-3'>
                <span>Switch Graph </span>
                <Switch
                    checkedChildren={<BarChartOutlined />}
                    unCheckedChildren={<LineChartOutlined />}
                    defaultChecked
                    style={{ backgroundColor: '#1677ff' }}
                    onChange={(event) => { setGraph(event) }}
                />
            </div>
        </div>
    );
};

export default LastTenDaysGraph;
